import React, { useState } from 'react';
import classNames from 'classnames';

import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Dropdown from '@sv-support-sdk/ui-components/src/components/Controls/Dropdown';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';
import Avatar from '@sv-support-sdk/ui-components/src/components/Media/Avatar';

import Button from '../../Controls/Button';
import Search from '../../Controls/Search';

import { useAppSelector } from '../../../store/hooks';
import {
  selectUserAvatar,
  userAuthorizedSelector,
  userFullNameSelector,
} from '../../../store/selectors/user';
import { WORKFLOW_FRONT_URL } from '../../../config';
import { $l } from '../../../locales';

import css from './style.module.scss';
import Options from '../../Lists/Options';
import setQaAttribute from '../../../helpers/setQaAttribute';
import { SUPPORT_HEADER_LOGIN, SUPPORT_HEADER_STATUS } from '../../../constants/qaAttributes';

interface IOption {
  [key: string]: any;
}

const Header = () => {
  const userAvatar = useAppSelector(selectUserAvatar);
  const userFullName = useAppSelector(userFullNameSelector);
  const isAuthorized = useAppSelector(userAuthorizedSelector);
  const [isUserMenuOpened, setUserMenuOpened] = useState(false);

  const userMenuOptions = [
    { key: 'logout', name: $l('HEADER.LOG_OUT'), icon: '20--logout-outlined' },
  ];

  const toggleUserMenu = (isOpened: boolean) => {
    setUserMenuOpened(isOpened);
  };

  const redirectToLogin = () => {
    window.location.href = `${WORKFLOW_FRONT_URL}/login?redirect=${window.location.href}`;
  };

  const selectUserOption = (option: IOption) => {
    if (option.key === 'logout') {
      window.location.href = `${WORKFLOW_FRONT_URL}/logout?redirect=${window.location.href}`;
    }
  };

  return (
    <div className={css.header}>
      <div className={css.header__section}>
        <div className={css.header__logo}>
          <Icon id="colored--32--question-mark" />
        </div>
        <Headline type="secondary" wrap="ellipsis">
          {$l('HEADER.TITLE')}
        </Headline>
      </div>
      <div className={classNames(css.header__section, css.header__section_align_center)}>
        <Search />
      </div>
      <div
        className={classNames(css.header__section, css.header__section_align_right)}
        {...setQaAttribute(SUPPORT_HEADER_STATUS)}
      >
        {isAuthorized ? (
          <Actions>
            <Dropdown
              options={userMenuOptions}
              value={null}
              trackBy="key"
              label="name"
              placement="right"
              listWidth="204"
              optionTextSize="md"
              onToggleList={toggleUserMenu}
              onSelect={selectUserOption}
              //@ts-ignore - expected error
              OptionsComponent={Options}
            >
              <Avatar
                img={userAvatar ? { src: userAvatar, alt: userFullName } : undefined}
                icon="colored--40--avatar"
                border={isUserMenuOpened ? 'blackOutline' : null}
              />
            </Dropdown>
          </Actions>
        ) : (
          <Actions>
            <ActionsItem width="140">
              <Button
                variant="primary-outlined"
                text={$l('HEADER.LOG_IN')}
                onClick={redirectToLogin}
                {...setQaAttribute(SUPPORT_HEADER_LOGIN)}
              />
            </ActionsItem>
          </Actions>
        )}
      </div>
    </div>
  );
};

export default Header;
